import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import PermissionEditor from '../../../../../../../../PermissionEditor'

export const CreateRoleModalBody: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.Administration.Roles.Name} />
      <DescriptionFormItem entityName="Role" />
      <CIMSFormItem name="permissionIds">
        <PermissionEditor help={HelpMessage.Administration.Roles.Permissions} />
      </CIMSFormItem>
    </>
  )
}

export type CreateRoleModalValues = {
  name: string
  description?: string
  permissionIds?: string[]
}
